// extracted by mini-css-extract-plugin
module.exports = {"card-not-found-block":"WhatForBlock_card-not-found-block__C8lCF","land-registration-guide":"WhatForBlock_land-registration-guide__GXPyw"};